import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ToastrAbstractionService {
  constructor(private _toastr: ToastrService) {}

  public success(title: string, message?: string | undefined): void {
    this._toastr.success(message, title);
  }

  public info(title: string, message?: string | undefined): void {
    this._toastr.info(message, title);
  }

  public warning(title: string, message?: string | undefined): void {
    this._toastr.warning(message, title);
  }

  public error(title: string, message?: string | undefined): void {
    this._toastr.error(message, title);
  }
}
